import styled from "styled-components";

export const ButtonContainer = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.redesign.b100};
    outline-offset: 2px;
    border-radius: 6px;
  }
`;

export const CareEventContainer = styled.div`
  width: 770px;
  overflow-y: auto;

  ${props => props.theme.belowBreakpoint} {
    width: auto;
  }
`;
